import useSWR from 'swr';

export const useOrganizationRoles = (fleetId, objectId) => {
  return useSWR(fleetId && objectId ? `organizationroles/fleets/${fleetId}/objects/${objectId}` : null);
};

export const useOrganizationRolesByOrganizationId = (organizationId) => {
  return useSWR(organizationId ? `organizationroles/organizations/${organizationId}` : null);
};
